import React from 'react';
import Icon from '../../../components/AppIcon';

const StarBalanceWidget = ({ balance }) => {
  const available = balance?.starsAvailable || 0;
  const total = balance?.totalStars || 0;
  const spent = balance?.starsSpent || 0;

  const spentPercentage = total > 0 ? Math.round((spent / total) * 100) : 0;

  return (
    <div className="bg-gradient-to-r from-amber-400 via-yellow-400 to-orange-400 rounded-2xl shadow-xl p-6 mb-6 text-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-40 h-40 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2" />
      <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/10 rounded-full translate-y-1/2 -translate-x-1/2" />

      <div className="relative z-10">
        <div className="flex items-center justify-between mb-4">
          <div>
            <p className="text-amber-100 text-sm font-medium mb-1">Your Star Balance</p>
            <div className="flex items-center space-x-2">
              <span className="text-5xl font-bold">{available}</span>
              <span className="text-2xl">⭐</span>
            </div>
            <p className="text-amber-100 text-xs mt-1">stars available to spend</p>
          </div>
          <div className="text-right">
            <div className="bg-white/20 rounded-xl p-4 backdrop-blur-sm">
              <div className="flex items-center space-x-6">
                <div className="text-center">
                  <p className="text-2xl font-bold">{total}</p>
                  <p className="text-amber-100 text-xs">Total Earned</p>
                </div>
                <div className="w-px h-10 bg-white/30" />
                <div className="text-center">
                  <p className="text-2xl font-bold">{spent}</p>
                  <p className="text-amber-100 text-xs">Stars Spent</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {total > 0 && (
          <div>
            <div className="flex justify-between text-xs text-amber-100 mb-1">
              <span>Stars used</span>
              <span>{spentPercentage}%</span>
            </div>
            <div className="h-2 bg-white/20 rounded-full overflow-hidden">
              <div
                className="h-full bg-white/70 rounded-full transition-all duration-700"
                style={{ width: `${spentPercentage}%` }}
              />
            </div>
          </div>
        )}

        {total === 0 && (
          <div className="flex items-center space-x-2 bg-white/20 rounded-lg px-3 py-2 mt-2">
            <Icon name="Info" size={14} className="text-amber-100" />
            <p className="text-amber-100 text-xs">Complete learning trails to earn stars!</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default StarBalanceWidget;
